import { makeActionCreator } from '../../utils/actionsUtils';
import { HIDE_MODAL, SHOW_MODAL } from './constants';

export const showModal = makeActionCreator(SHOW_MODAL, 'modalType', 'modalProps');
export const hideModal = makeActionCreator(HIDE_MODAL);



// WEBPACK FOOTER //
// ./src/services/modal/actions.js